import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { ErrorMapperService } from '@services';
import { unsubscribe } from '@utils/object.utils';

import { Subscription } from 'rxjs';

@Component({
    templateUrl: 'email-confirmation.page.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailConfirmationPageComponent implements OnDestroy {
    public errorMessage: string | null = null;

    private _routeParamSub?: Subscription;

    constructor(
        router: Router,
        errorMapperService: ErrorMapperService,
    ) {
        const params = router.routerState.snapshot.root.queryParamMap;
        const errorCodeParam = params.get('errorCode');
        if (errorCodeParam) {
            this._routeParamSub =
                errorMapperService.auth
                    .subscribe((errorCodes: { [x: string]: string; }) => {
                        this.errorMessage = errorCodes[errorCodeParam];
                    });
        }
    }

    ngOnDestroy() {
        unsubscribe(
            this._routeParamSub,
        );
    }
}
